// @flow
import get from 'lodash/get';
import PropTypes from 'prop-types';

export type Experience = {
  display_data: Object,
  experience_id: number,
  id: string,
  isContextual?: boolean,
  placement_id: number,
  triggerable_placed_exps: Array<string>,
  type: number,
  complete?: () => void,
  dismiss?: () => void,
};
export type ExperienceMap = { [key: number]: Experience };
export type AnchorExperienceMap = { [key: string]: Experience };
export type PlacementMountMap = { [key: number]: boolean };

export const ExperienceProps = {
  display_data: PropTypes.shape({}),
  experience_id: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  placement_id: PropTypes.number.isRequired,
  triggerable_placed_exps: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.number.isRequired,
};

export function isRenderableExperience(experience: Experience) {
  return experience ? experience.type !== PCONST.thrift.ExperienceType.NOOP : false;
}

export function getExperienceAnchor(experience: Experience) {
  // TODO (hfu): update to not use string anchors; requires:
  // 1) update ehq schema
  // 2) add thrift types like in ios tooltips
  // 3) update all tooltip experiences to use new types
  // 4) support types in client code
  // 5) update tooltip schema to remove anchors
  // 6) remove support for string anchors
  return get(experience, ['display_data', 'anchor']);
}

export function getPlacedExperienceId(
  placementId: number,
  experienceId: number,
  experienceMap: ExperienceMap,
  isBackendExperience?: boolean,
) {
  // API-79: %3A is the encoded ':', need double encode to match api signature
  if (isBackendExperience && !!placementId && !!experienceId) {
    return `${placementId}%3A${experienceId}`;
  }

  const placedExperience = experienceMap[placementId];
  if (placedExperience) {
    if (placedExperience.experience_id === experienceId) {
      return placedExperience.id.replace(':', '%3A');
    }
  }
  return null;
}

export function addAnchorExperience(
  anchorExperiences: AnchorExperienceMap,
  experience: Experience,
) {
  if (experience && experience.type === PCONST.thrift.ExperienceType.TOOLTIP) {
    anchorExperiences[getExperienceAnchor(experience)] = experience;
  }
}
